import { fromEntries } from '@/helpers/javascript'
import api from '@/api'
import {Module} from 'vuex'
import {Definition} from '@/api/schema'

const state = () => ({
	entities: {} as Record<string, Definition>
})

export type SchemaState = ReturnType<typeof state>

const store: Module<SchemaState, SchemaState> = {
	namespaced: true,
	state,
	getters: {},
	actions: {
		async fetchEntities ({ commit }) {
			const response = await api.schema.getEntities()
			commit('SET_ENTITIES', response.data)
		}
	},
	mutations: {
		SET_ENTITIES (state, entities: Definition[]) {
			state.entities = fromEntries(entities.map(e => [e.name, e]))
		}
	}
}

export default store
